import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@et/environment';
import { Observable, map, catchError, of, retry } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IpService {
  private http = inject(HttpClient);

  /**
   * This function retrieves the client's IP address from the 'ipify' API.
   * If the request fails for any reason, it returns 'n/a'.
   *
   * @returns {Observable<string>} An Observable that emits the client's IP address, or 'n/a' if the request fails.
   */
  getMyIP(): Observable<string> {
    return this.http
      .get(environment.packetService.domain + '/api/packet/file/getIP', {
        responseType: 'text',
      })
      .pipe(
        retry(2),
        catchError((error) => {
          console.error(error);
          return this.backup();
        }),
      );
  }

  private backup() {
    return this.http
      .get<{ ip: string }>('https://api.ipify.org/?format=json')
      .pipe(
        map((res) => res.ip),
        retry(2),
        catchError((error) => {
          console.error(error);
          return of('n/a');
        }),
      );
  }
}
